<template>
  <section id="bookings-section">
    <h1 class="title">{{$resx('DirectBookingsText')}}</h1>
    <h2 class="subtitle">{{$resx('BookingsSubTitleText')}}</h2>
    <div class="text-center" v-if="isLoadingSummary">
        <i class="loading material-icons">cached</i>
    </div>
    <div v-if="campingData!==null">
      <header>
        <h3>{{$resx('BookingsConnectionTitleText')}}</h3>
        <template v-if="campingData.provider!==null">
          <p v-html="$resx('BookingPartnerInfoText', [campingData.provider.name, campingData.provider.externalId])"></p>
          <div v-if="campingData.provider.usePayzenShop">
            <p v-html="$resx('PayzenProcessText')"> </p>
            <p v-if="campingData.provider.id !== 7" v-html="$resx('CancellationInsurranceDocumentsText')"></p>
          </div>
          <iban-editor :show="displayIbanEditor" :iban="iban" @onIbanModalClose="hideIbanModal"></iban-editor>
        </template>
        <template v-else>
          <p v-html="$resx('NoProviderText')"></p>
        </template>
      </header>
      <div v-if="campingData.provider!==null">
        <div v-if="campingData.provider.usePayzenShop || campingData.provider.id === 1">
          <h3>{{$resx('MyBookingsInfoText')}}</h3>
          <table class="mytable info">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>{{$resx('BookingInfoValueText')}}</th>
                <th>{{$resx('BookingInfoValidText')}}</th>
                <th>{{$resx('BookingInfoUpdateText')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="doc in documents" :key="doc.code">
                <td>{{doc.label}}</td>
                <td><a v-if="doc.isLink" :href="doc.value" rel="noreferrer" target="_blank">{{doc.value}}</a> <span v-else>{{doc.value}}</span></td>
                <td class="status">
                  <span v-if="doc.isValid" class="material-icons valid">done</span>
                  <span v-else class="material-icons invalid">cancel</span>
                  <span v-html="doc.validationMessage"></span>
                </td>
                <td><a class="iban-link" @click="doc.callbackMethod">{{$resx('ClickHereText')}}</a>{{doc.updateMessage}}</td>
              </tr>
            </tbody>
          </table>
          <insurrance-link :show="displayInsurranceEditor" :doc="selectedDocument" @onInsurranceLinkClose="hideInsurranceModal"></insurrance-link>
        </div>
        <div class="flex">
          <h3>{{$resx('BookingsListTitleText')}}</h3>
          <div class="season">
            <span>Saison</span>
            <select class="select" v-model.number="currentYear" @change="loadBookings">
              <option :value="null" disabled>{{$resx('SelectSeasonText')}}</option>
              <option v-for="year in years" :key="year" :value="year">{{year}}</option>
            </select>
          </div>
        </div>
        <table class="mytable bookings">
          <thead>
            <tr>
              <th>{{$resx('CommandNumberText')}}</th>
              <th>{{$resx('ClientNameText')}}</th>
              <th>{{$resx('BookingDateText')}}</th>
              <th>{{$resx('StartTripDateText')}}</th>
              <th>{{$resx('EndTripDateText')}}</th>
              <th>{{$resx('AccomodationText')}}</th>
              <th>{{$resx('DepositText')}}</th>
              <th>{{$resx('TotalPriceText')}}</th>
              <th>{{$resx('StatusText')}}</th>
              <th v-if="campingData.provider.usePayzenShop">{{$resx('PaymentText')}}</th>
            </tr>
          </thead>
          <tbody v-if="hasBookings">
            <tr v-for="item in bookings" :key="item.id">
              <td>{{item.commandNumber}}</td>
              <td>{{item.booker}}</td>
              <td>{{item.formatedBookingDate}}</td>
              <td>{{item.formatedTripStartDate}}</td>
              <td>{{item.formatedTripEndDate}}</td>
              <td>{{item.accomodation}}</td>
              <td>{{item.formatedDeposit}}</td>
              <td>{{item.formatedPrice}}</td>
              <td><i class="material-icons status" :data-status="item.status">{{item.statusIcon}}</i></td>
              <td v-if="campingData.provider.usePayzenShop"><button v-if="item.hasPaymentInfo" class="btn" @click="displayPaymentDetailsModals(item.id)">{{$resx('PaymentInfoText')}}</button></td>
            </tr>
          </tbody>
          <tfoot v-if="isLoadingBookings">
            <tr>
              <td :colspan="campingData.provider.usePayzenShop ? 10 : 9" class="text-center">
                <i class="loading material-icons">cached</i>
              </td>
            </tr>
          </tfoot>
          <tfoot v-else-if="!hasBookings">
            <tr>
              <td :colspan="campingData.provider.usePayzenShop ? 10 : 9">{{$resx('NoBookingsText')}}</td>
            </tr>
          </tfoot>
        </table>
        <div class="export flex flex-just-center" v-if="hasBookings">
          <button class="btn btn-small btn-secondary flex" @click="downloadReport(false)"><span class="material-icons">save_alt</span>{{$resx('BookingDownloadCampingReportText')}}</button>
          <button class="btn btn-small btn-secondary flex" v-if="partner.isGroup" @click="downloadReport(true)"><span class="material-icons">save_alt</span>{{$resx('BookingDownloadGroupReportText')}}</button>
        </div>
        <payment-details :show="displayPaymentDetails" :id="selectedBookingId" @onPaymentDetailsClose="hidePaymentDetailsModal"></payment-details>
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
import Booking from '../models/booking/booking'
import BookingCamping from '../models/booking/bookingCamping'
import Iban from '../models/booking/iban'
import bookingServices from '../services/bookingServices'
import bankServices from '../services/bankServices'
import ibanEditor from '../components/bank/ibanEditor.vue'
import insurranceEditor from '../components/bookings/insurranceEditor.vue'
import paymentDetailsModal from '../components/bank/bookingPaymentDetails.vue'
import Insurrance from '../models/booking/insurrance'
import TableDocument from '../models/booking/document'

export default {
  name: 'Booking',
  data () {
    return {
      isLoadingBookings: false,
      isLoadingSummary: false,
      bookings: null,
      campingData: null,
      currentYear: null,
      iban: undefined, // volontaire pour detecter le changement lorsque passe a null
      displayIbanEditor: false,
      displayPaymentDetails: false,
      displayInsurranceEditor: false,
      selectedBookingId: null,
      selectedDocument: null,
      insurrances: [],
      documents: []
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },
    // annees de selection
    years () {
      var tab = []
      var maxYear = moment().year()
      // les mois dans moments.js sont de 0 à 11
      if (moment().month() >= 9) {
        maxYear++
      }
      if (this.campingData != null) {
        for (var i = maxYear; i >= this.campingData.startYear; i--) {
          tab.push(i)
        }
      }
      return tab
    },
    // y a t'il des réservations
    hasBookings () {
      return this.bookings != null && this.bookings.length > 0
    }
  },
  watch: {
    // détecter un changement de camping
    currentCampingId: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadBookingSummary()
      }
    },

    // modification Iban
    iban: function () {
      this.updateIbanDocument()
    }
  },
  methods:
  {
    // charger les infos personnelles
    async loadBookingSummary () {
      this.isLoadingSummary = true
      this.bookings = null
      this.iban = null
      this.currentYear = null
      this.documents = []
      try {
        const response = await bookingServices.loadSummary(this.currentCampingId)
        this.campingData = new BookingCamping(response)
        if (this.campingData.provider !== null) {
          if (this.campingData.provider.usePayzenShop) {
            // charger les infos d'assurance
            await this.loadDocuments()
          }
          if (this.campingData.provider.usePayzenShop || this.campingData.provider.id === 1) {
            // charger les infos de l'iban
            await this.loadIban()
          }
        }
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      }
      this.isLoadingSummary = false
    },

    // charger l'iban d'un camping
    async loadIban () {
      try {
        const response = await bankServices.loadIban(this.currentCampingId)
        if (response) {
          this.iban = new Iban(response)
        } else {
          this.iban = null
        }
        this.updateIbanDocument()
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      }
    },

    // charger les assurance annulations
    async loadDocuments () {
      try {
        this.insurrances = []
        const response = await bookingServices.loadDocuments(this.currentCampingId)
        if (response) {
          response.forEach(x => {
            var assu = new Insurrance()
            assu.code = x.key
            assu.language = x.key.slice(-2)
            assu.value = x.value
            this.insurrances.push(assu)
          })
          this.updateDocuments()
        }
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      }
    },

    // charger les réservations
    async loadBookings () {
      this.isLoadingBookings = true
      try {
        this.bookings = []
        var bookings = await bookingServices.loadBookings(this.currentCampingId, this.currentYear)
        bookings.forEach((item) => {
          this.bookings.push(new Booking(item))
        })
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      }
      this.isLoadingBookings = false
    },

    // tableau de documents
    updateDocuments () {
      this.insurrances.forEach((x) => {
        var assuDoc = new TableDocument()
        assuDoc.code = x.code
        assuDoc.callbackMethod = () => {
          this.displayInssuranceModal(assuDoc)
        }
        assuDoc.isLink = true
        if (assuDoc.code.startsWith('bookAssu_')) {
          assuDoc.label = this.$resx('CancellationInsurranceText')
        } else if (assuDoc.code.startsWith('bookCgv')) {
          assuDoc.label = this.$resx('SalesConditionsText')
        }
        assuDoc.label += ' (' + x.language + ')'
        assuDoc.isValid = false
        assuDoc.validationMessage = x.value === null ? this.$resx('MissingLinkText') : ''
        // ibanDoc.updateMessage = this.$resx('InsertIbanText')
        assuDoc.value = x.value
        this.documents.push(assuDoc)
      })

      this.documents.forEach((x) => {
        if (x.isLink && x.value !== null) {
          this.checkLink(x)
        }
      })
    },

    updateIbanDocument () {
      var ibanDoc = this.documents.find(x => x.code === 'iban')
      if (ibanDoc === undefined || ibanDoc === null) {
        ibanDoc = new TableDocument()
        ibanDoc.code = 'iban'
        ibanDoc.label = this.$resx('IbanNumberText')
        ibanDoc.callbackMethod = this.displayIbanModal
        this.documents.unshift(ibanDoc)
      }
      // console.log('ibanDoc 2', ibanDoc)
      if (this.iban == null) {
        ibanDoc.isValid = false
        ibanDoc.updateMessage = this.$resx('InsertIbanText')
        ibanDoc.validationMessage = this.$resx('EmptyIbanText')
      } else {
        ibanDoc.isValid = true
        ibanDoc.updateMessage = this.$resx('UpdateIbanText')
        ibanDoc.validationMessage = this.$resx('YesText')
        ibanDoc.value = this.iban.iban
      }
    },

    // verifie si un lien est valide
    async checkLink (item) {
      var ok = false
      try {
        ok = await bookingServices.checkDocumentUrl(item.value)
      } catch (e) {
        console.warn('error acces à l\'url ' + item.value)
      }
      if (ok) {
        item.isValid = true
        item.validationMessage = this.$resx('ValidLinkText')
      } else {
        item.isValid = false
        item.validationMessage = this.$resx('InvalidLinkText')
      }
    },

    // afficher la popup iban
    displayIbanModal () {
      this.displayIbanEditor = true
    },

    // afficher la popup pour enregsitrer le lien d'une assurance
    displayInssuranceModal (assu) {
      this.selectedDocument = assu
      this.displayInsurranceEditor = true
    },

    // cacher la popup iban
    hideIbanModal (newIban) {
      this.displayIbanEditor = false
      if (newIban !== undefined && newIban !== null) {
        this.iban = newIban
      }
    },

    // cacher la popup doc assurance
    hideInsurranceModal (doc) {
      this.displayInsurranceEditor = false
      if (doc !== undefined && doc !== null) {
        this.documents.forEach((x) => {
          if (x.code === doc.code) {
            x.value = doc.value
            x.isValid = doc.value
            x.validationMessage = doc.validationMessage
          }
        })
      }
    },

    // afficher la popup de details des paiements
    displayPaymentDetailsModals (id) {
      this.selectedBookingId = id
      this.displayPaymentDetails = true
    },

    // cacher la popup de details des paiements
    hidePaymentDetailsModal () {
      this.displayPaymentDetails = false
      this.selectedBookingId = null
    },

    // téléchargement du rapport des résas
    async downloadReport (byGroup) {
      try {
        bookingServices.loadBookingsReport(this.currentYear, !byGroup ? this.currentCampingId : null)
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      }
    }
  },
  components: {
    'iban-editor': ibanEditor,
    'payment-details': paymentDetailsModal,
    'insurrance-link': insurranceEditor
  },
  async mounted () {
    this.$store.commit('app/setPage', 'bookings')
    await this.loadBookingSummary()
  }
}

</script>
<style  src="../assets/bookings.less" lang="less"></style>
